export const BASE_BACKEND_URL = 'http://localhost:3000'